import {
  Box,
  Chip,
  Tooltip
} from '@mui/material'
import { useContext } from 'react'
import { SaveDataContext } from 'src/store/save/Store'

const itemBlockStyle = {
  border: '1px dashed white',
  color: 'white',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent'
  }
}

const currencyCountStyle = {
  height: '16px',
  width: '16px',
  color: 'black',
  backgroundColor: 'white',
  position: 'absolute',
  right: '-8px',
  bottom: 0,
  span: {
    fontSize: '12px',
    padding: 0
  }
}

type CurrencyBlockProps = {
  currencyID: string
  color?: string
}

const CurrencyBlock = ({ currencyID, color = 'white'}: CurrencyBlockProps) => {
  const { save } = useContext(SaveDataContext)
  const quantity = save.counters.cigs || 0
  return (
    <Tooltip title={currencyID}>
      <Box sx={{position: 'relative'}}>
      <Chip sx={{...itemBlockStyle, borderColor: color, color}} label={currencyID.substring(0, 1).toUpperCase()} className='currency'/>
      <Chip sx={{...itemBlockStyle, ...currencyCountStyle}} label={quantity} className='currency_count'/>
      </Box>
    </Tooltip>
  )
}

export default CurrencyBlock
